(function (window) {
  const nav = document.querySelector('sticky-header');
  document.documentElement.style.setProperty('--nav-height', nav.getBoundingClientRect().height + 'px');

  window.addEventListener('resize', () => {
    document.documentElement.style.setProperty('--nav-height', nav.getBoundingClientRect().height + 'px');
  });
})(window);
